export * from './message.component';
export * from './register-message';
export * from './upgrade-message';
export * from './arrival-message';
export * from './profile-popup';



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/message/index.ts